import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from 'react'

import ObjTabsHomeComptoirDermato from './inc/ObjTabsHomeComptoirDermato'

import '../assets/css/0020_objects/0880_obj_intro_home_comptoir_dermato.css'
import '../assets/css/0020_objects/0890_obj_tabs_home_comptoir_dermato.css'

class PageBrandAv_TabsSegments extends Component {
    constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
        const { scDatas } = this.props.fields.data;

        return (<>{scDatas?.ListSegmentFolder[0].ListSegment && <>
			<section className="obj_section obj_tabs_home_comptoir_dermato">
				<div className="ctn_section">

					<ObjTabsHomeComptoirDermato datasSegments = {scDatas?.ListSegmentFolder[0].ListSegment}/>

				</div>
			</section>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(PageBrandAv_TabsSegments));